import React, { forwardRef } from "react";

import { IExpander } from "./ExpanderInterface";
import { StyledExpand } from "./Styles";

export const ExpandAll = forwardRef<
  SVGSVGElement,
  IExpander & React.ComponentPropsWithoutRef<"svg">
>(({ expanded = false, ...rest }, ref) => {
  return (
    <StyledExpand ref={ref} viewBox="0 0 24 24" {...rest}>
      {expanded ? (
        <path d="M13 16l4.72 4.461a.867.867 0 010 1.275.993.993 0 01-1.348 0L13 18.549l-3.372 3.187a.993.993 0 01-1.349 0 .867.867 0 010-1.275L13 16zm4.72-11.736a.867.867 0 010 1.275L13 10 8.28 5.539a.867.867 0 010-1.275.993.993 0 011.348 0L13 7.451l3.372-3.187a.993.993 0 011.349 0zM13 15a2 2 0 100-4 2 2 0 000 4z" />
      ) : (
        <path d="M17.72 16.264a.867.867 0 010 1.275L13 22l-4.72-4.461a.867.867 0 010-1.275.993.993 0 011.348 0L13 19.451l3.372-3.187a.993.993 0 011.349 0zM13 4l4.72 4.461a.867.867 0 010 1.275.993.993 0 01-1.348 0L13 6.549 9.628 9.736a.993.993 0 01-1.349 0 .867.867 0 010-1.275L13 4zm0 11a2 2 0 100-4 2 2 0 000 4z" />
      )}
    </StyledExpand>
  );
});

ExpandAll.displayName = "ExpandAll";
